import React from 'react';
import { CoverTemplate } from '../../../templates/types';
import { Card } from '../../../shared/components/Card';
import { Button } from '../../../shared/components/Button';
import { Check, Sparkles } from 'lucide-react';

interface TemplateCardProps {
  template: CoverTemplate;
  isSelected?: boolean;
  onSelect: (template: CoverTemplate) => void;
}

export const TemplateCard: React.FC<TemplateCardProps> = ({
  template,
  isSelected,
  onSelect,
}) => {
  return (
    <Card
      interactive
      onClick={() => onSelect(template)}
      style={{
        border: isSelected ? '2px solid var(--primary-600)' : '1px solid var(--border-subtle)',
        backgroundColor: isSelected ? 'var(--primary-50)' : 'var(--bg-surface)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: 'var(--space-4)',
        gap: 'var(--space-3)',
      }}
    >
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-2)' }}>
          <span className="badge badge-neutral" style={{ fontSize: '10px', textTransform: 'uppercase' }}>
            {template.category.replace('_', ' ')}
          </span>
          {template.thumbnailBadge && (
            <span className="badge badge-primary" style={{ fontSize: '10px' }}>
              <Sparkles size={10} /> {template.thumbnailBadge}
            </span>
          )}
        </div>

        <h3 style={{ fontSize: 'var(--font-size-sm)', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4 }}>
          {template.name}
        </h3>
        <p style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)', lineHeight: 1.4 }}>
          {template.description}
        </p>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'var(--space-2)' }}>
        <span style={{ fontSize: '11px', color: 'var(--text-tertiary)' }}>
          {template.supportedFields.length} fields supported
        </span>

        <Button
          variant={isSelected ? 'primary' : 'secondary'}
          size="sm"
          icon={isSelected ? <Check size={13} /> : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(template);
          }}
        >
          {isSelected ? 'Active Template' : 'Use Template'}
        </Button>
      </div>
    </Card>
  );
};
